import { Box, Dropdown, MenuButton, Menu, MenuItem, Stack } from '@mui/joy';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ImageIcon from '@mui/icons-material/Image';
import { Typography, Drawer, DialogTitle, ModalClose } from '@mui/joy';
import { AddNavigationButton } from '@/components/AddNavigationButton';
import { useState } from 'react';
import { Button } from '@/ui/Button';

export function AddRecipeButton({ type }) {  
  const [open, setOpen] = useState(false);

  const menuItems = [
    { label: 'From URL', icon: LinkIcon, to: './from-url' },
    { label: 'From Text', icon: TextFieldsIcon, to: './from-text' },
    { label: 'From Image', icon: ImageIcon, to: './from-image' },
    { label: 'Manually', icon: AddIcon, to: './create' },
  ];

  if (type === 'mobile') {
    return (
      <Box sx={{ display: 'flex', width: 'auto', justifyContent: 'center' }}>  
        <AddNavigationButton onClick={() => setOpen(true)} />
        <Drawer open={open} onClose={() => setOpen(false)} anchor="bottom" sx={{ '.MuiDrawer-content': { height: '160px' } }}>                    
          <Box sx={{ p: 2, pb: 1 }}>            
            <DialogTitle>Add Recipe</DialogTitle>          
            <ModalClose />             
          </Box>            
          <Stack direction="row" gap={2} sx={{ width: '100%', justifyContent: 'space-between', px: 3, py: 2 }}>
            {menuItems.map((item) => (
              <Link to={item.to} key={item.to} onClick={() => setOpen(false)}>                  
                <Stack direction="column" gap={1} alignItems="center">
                  <Box sx={{ backgroundColor: 'var(--joy-palette-neutral-100)', p: 1, width: '48px', height: '48px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <item.icon sx={{ fontSize: '24px' }} />                   
                  </Box>
                  <Typography level="body-xs">{item.label}</Typography>
                </Stack>
              </Link>
            ))}
          </Stack>              
        </Drawer>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', width: 'auto', justifyContent: 'stretch' }}>
      <Dropdown>
        <Button component={MenuButton} color="primary" shape="pill" startDecorator={<AddIcon/>} sx={{ width: 'auto' }}>
          Add Recipe
        </Button>
        <Menu placement="bottom-end" sx={{ width: { xs: 'calc(100% - 1em)', sm: 'auto' } }}>                                       
         {menuItems.map((item) => (
          <Link to={item.to} key={item.to}><MenuItem><item.icon sx={{ mr: 1 }} />{item.label}</MenuItem></Link>
         ))}         
        </Menu>
      </Dropdown>
    </Box>
  );
}